import React, { useState, useEffect } from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ResponsiveContainer,
    LabelList,
} from "recharts";

import {
    compareMonthLabels,
    earliestYearMonth,
    getMonthLabelsInRange,
} from "../../utils/monthRange";
import CustomLabel from "./CustomLabel";
import CustomTooltip from "./CustomTooltip";

const BookingsCompositionStackedBarChart = ({
    props,
    onLoad,
    onDataStart,
    startMonth,
    endMonth,
}) => {
    const [carrData, setCarrData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const fetchMetrics = () => {
        setIsLoading(true);
        props
            .fetchData("getstackedbookingcomposition")
            .then((data) => {
                const metricsData = data || [];
                // Backend month order is not guaranteed; sort chronologically
                metricsData.sort((a, b) => compareMonthLabels(a.month, b.month));
                setCarrData(metricsData);
                if (onDataStart) onDataStart(earliestYearMonth(metricsData.map((d) => d.month)));
            })
            .catch((error) => console.error("Error fetching metrics:", error))
            .finally(() => {
                setIsLoading(false);
                if (onLoad) onLoad();
            });
    };

    useEffect(() => {
        fetchMetrics();
    }, []);

    const allowedMonths = getMonthLabelsInRange(startMonth, endMonth);
    const visibleData = carrData.filter((d) => allowedMonths.includes(d.month));

    return (
        <div className="mb-32">
            {isLoading ? (
                onLoad ? null : (
                    <h4 className="px-2 pt-8 text-center">Loading Bookings Composition...</h4>
                )
            ) : visibleData.length > 0 ? (
                <>
                    <h2>Bookings Composition</h2>
                    <div className="pt-1">
                        <ResponsiveContainer width="100%" height={400}>
                            <BarChart
                                data={visibleData}
                                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
                            >
                                <XAxis dataKey="month" />
                                <YAxis
                                    type="number"
                                    domain={[0, 1250000]}
                                    allowDataOverflow={true}
                                    tickFormatter={(value) => value.toLocaleString()}
                                />
                                {/* <Tooltip formatter={(value) => value.toLocaleString()} /> */}
                                <Tooltip content={<CustomTooltip />} />
                                <Legend />
                                <Bar dataKey="New CARR" stackId="a" fill="#004b6e" />{" "}
                                {/* Deep Navy Blue */}
                                <Bar
                                    dataKey="Non Cross-Sell CARR"
                                    stackId="a"
                                    fill="#2f6f8f"
                                />{" "}
                                {/* Slate Blue */}
                                <Bar dataKey="Cross-Sell CARR" stackId="a" fill="#5b8fa9" />{" "}
                                {/* Muted Steel Blue */}
                                <Bar
                                    dataKey="Total Bookings"
                                    label={<CustomLabel data={visibleData} />}
                                    fill="transparent"
                                    isAnimationActive={false}
                                ></Bar>
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </>
            ) : (
                <h3 className="px-2 pt-8 text-center">No metrics available.</h3>
            )}
        </div>
    );
};

export default BookingsCompositionStackedBarChart;
